module.exports = __webpack_public_path__ + "img/icon_classification.ab014fa4.png";